import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import SubscriptionGate from './components/SubscriptionGate';
import Workspace from './components/Workspace';
import DSWorkspace from './components/DSWorkspace';
import Login from './components/Login';
import Register from './components/Register';
import SubscriptionPage from './components/SubscriptionPage';
import AdminDashboard from './components/AdminDashboard';
import AdminRoute from './components/AdminRoute';
import SharedNotebookView from './components/SharedNotebookView';
import PaymentSuccessPage from './components/PaymentSuccessPage';
import GitHubCallback from './components/GitHubCallback';
import LovableLanding from './LovableLanding';
import InviteOnlyPage from './components/InviteOnlyPage';
import HackathonPage from './components/HackathonPage';
import HackathonLeaderboard from './components/HackathonLeaderboard';
import HackathonDashboard from './components/HackathonDashboard';
import HackathonFeedback from './components/HackathonFeedback';
import CertificateView from './components/CertificateView';
import { GOOGLE_CLIENT_ID } from './config';
import './App.css';

function App() {
  // ✅ Define INSIDE App so it's always within AuthProvider + Router context
  const HomeRoute = () => {
    const { user, loading } = useAuth();
    if (loading) return <div style={{ color: '#fff', padding: '2rem' }}>Loading...</div>;
    if (user) return <SubscriptionGate><Workspace /></SubscriptionGate>;
    return <InviteOnlyPage />;
  };

  return (
    // GoogleOAuthProvider wraps the entire app for Google OAuth
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<HomeRoute />} />
            <Route path="/login" element={<InviteOnlyPage />} />
            <Route path="/register" element={<InviteOnlyPage />} />
            <Route path="/auth/callback/github" element={<GitHubCallback />} />
            {/* <Route path="/auth/callback/google" element={<GitHubCallback />} /> */}
            <Route path="/hackathon" element={<HackathonPage />} />
            <Route path="/hackathon/leaderboard" element={<HackathonLeaderboard />} />
            <Route path="/hackathon/dashboard" element={<HackathonDashboard />} />
            <Route path="/hackathon/feedback" element={<HackathonFeedback />} />
            <Route path="/certificate/:certId" element={<CertificateView />} />
            <Route path="/ds-workspace" element={
              <ProtectedRoute><SubscriptionGate><DSWorkspace /></SubscriptionGate></ProtectedRoute>
            } />
            {/* Temporarily hidden for hackathon */}
            {/* <Route path="/subscription" element={
              <ProtectedRoute><SubscriptionPage /></ProtectedRoute>
            } /> */}
            {/* <Route path="/payment-success" element={<PaymentSuccessPage />} /> */}
            <Route path="/admin" element={
              <AdminRoute><AdminDashboard /></AdminRoute>
            } />
            <Route path="/shared/:notebookId/:title" element={<SharedNotebookView />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
